import { FC } from 'react';
import { ProSelect } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { SelectProps } from 'antd/lib/select';

export interface SimpleFormSelectProps extends BaseSimpleFormProps {
  selectProps?: SelectProps<any>;
  enumCode?: string;
}
const SimpleFormSelect: FC<SimpleFormSelectProps> = props => {
  const { disabledRender, selectProps, form, enumCode, ...restProps } = props;
  const { enumData } = useLayoutContext();
  let options: any[] = [];
  if (enumCode && enumData) {
    options = enumData[enumCode] ? enumData[enumCode].items || [] : [];
  }
  const handleFilterOption = (inputValue: string | number, option: any) => {
    return option.label.includes(inputValue);
  };
  return (
    <SimpleFormItem {...restProps}>
      {selectProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          options={selectProps?.options || options}
          render={disabledRender}
        />
      ) : (
        <ProSelect
          allowClear
          showSearch
          style={DEFAULT_STYLE}
          filterOption={handleFilterOption}
          {...selectProps}
          options={selectProps?.options || options}
        />
      )}
    </SimpleFormItem>
  );
};

SimpleFormSelect.displayName = SimpleFormItemEnum.SimpleFormSelect;

export default SimpleFormSelect;
